export const SUB_BTN_TEXT = {
  PROCESS: '정보 수정을 원하시나요?',
  SUBMITTED: '동의 철회 및 정보 변경을 원하시나요?',
  COMPLETE: '작성한 내용 확인하기',
};

export const USER_INFO_KEYS = [
  'usrNm',
  'usrBirthday',
  'ptNo',
  'hsptlzWardRoom',
  'hsptlzWard',
  'hsptlzRoom',
  'deptNm',
  'medrNm',
  'usrTelNo',
  'postNo',
  'bscAddr',
  'dtlAddr',
  'usrRrn',
  'sex',
  'typeAssistance',
  'hsptlzDate',
  'phoneNumberList',
  'advancedRoomFee',
  'insuranceType',
  'roomGrade',
  'caregiverRelationship',
  'caregiverName',
  'caregiverBirthDate',
  'caregiverSex',
  'caregiverPhoneNumber',
  'caregiverPostNumber',
  'caregiverAddress',
  'caregiverDetailAddress',
];

export const ERROR_MESSAGE = {
  tel: '연락처가 정확한지 확인해 주세요.',
};
